import { createActions } from 'redux-actions';

export const {
  getVehicleById,
  getVehicleByIdSuccess,
  getVehicleByIdError,
  createVehicle,
  createVehicleSuccess,
  createVehicleError,
  createVehicleClearError,
  updateVehicle,
  updateVehicleSuccess,
  updateVehicleError,
  updateVehicleStatus,
  updateVehicleStatusSuccess,
  updateVehicleStatusError,
  clearErrors,
} = createActions(
  'GET_VEHICLE_BY_ID',
  'GET_VEHICLE_BY_ID_SUCCESS',
  'GET_VEHICLE_BY_ID_ERROR',
  'CREATE_VEHICLE',
  'CREATE_VEHICLE_SUCCESS',
  'CREATE_VEHICLE_ERROR',
  'CREATE_VEHICLE_CLEAR_ERROR',
  'UPDATE_VEHICLE',
  'UPDATE_VEHICLE_SUCCESS',
  'UPDATE_VEHICLE_ERROR',
  'UPDATE_VEHICLE_STATUS',
  'UPDATE_VEHICLE_STATUS_SUCCESS',
  'UPDATE_VEHICLE_STATUS_ERROR',
  'CLEAR_ERRORS'
);
